import React from "react";
import "./textEffect.css";

interface TextEffectProps {
  text: string;
}

const TextEffectTopLeft: React.FC<TextEffectProps> = ({ text }) => {
  return (
    <div className="container">
      <div className="text-effect" data-text={text}>
        <span className="clone clone-1" data-text={text}>{text}</span>
        <span className="clone clone-2" data-text={text}>{text}</span>
        <span className="clone clone-3" data-text={text}>{text}</span>
        <span className="clone clone-4" data-text={text}>{text}</span>
        <span className="clone clone-5" data-text={text}>{text}</span>
        <span className="main-text">{text}</span>
      </div>
    </div>
  );
};

export default TextEffectTopLeft;